module.exports = __webpack_public_path__ + "static/media/msg.2ec1080b.svg";